import axios from "@/libs/api.request";
// 获取列表
export const proxyErr = params => {
  return axios.request({
    url: "/tracker/pushAgentData",
    method: "get",
    params
  });
};

export const pushProxy = data => {
  return axios.request({
    url: `/tracker/pushAgentData/secondPush`,
    method: "post",
    data
  });
};

// export const saveProxy = (id, data) => {
//   return axios.request({
//     url: `/pushAgentException/save//${id}`,
//     method: "post",
//     data
//   });
// };
